import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetConfigurationDictionariesQuery } from '../../store/dictionaries/service';

import { CardsRoutes } from '../../routes';

import cn from './cards.module.css';

const Cards = (): React.JSX.Element => {
  const navigate = useNavigate();
  const match = useMatch(CardsRoutes.CARDS);

  const { activePermissions, riskScoreRanges } = useAppSelector(
    (state) => state.configurationDictionaries,
  );

  const [getDictionaries] = useLazyGetConfigurationDictionariesQuery();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions?.includes(PermissionEnum.SECTION_CARDS)
    ) {
      if (!riskScoreRanges) {
        getDictionaries();
      }

      if (activePermissions.includes(PermissionEnum.CARDS_LIST)) {
        if (match) {
          navigate(CardsRoutes.CARDS_LIST);
        }
      }
    }
  }, [match, activePermissions, riskScoreRanges]);

  useEffect(() => {
    let title = 'Cards';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.cardsLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_CARDS) ||
      !activePermissions.includes(PermissionEnum.CARDS_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.cards}>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default Cards;
